import { HelpVideoIconComponent } from './help-video-icon/help-video-icon.component'
import { PageHelpComponent } from './page-help/page-help.component'
import { OverflowScrollComponent } from './overflow-scroll/overflow-scroll.component'
import { CircleProgressComponent } from './circle-progress/circle-progress.component'
import { UploadBoxComponent } from './UploadBox/UploadBox.component'
import { TinyMceEditorComponent } from './TinyMceEditor/TinyMceEditor.component'
import { MatPaginator2 } from './MatPaginator2/MatPaginator2.component'
import { LoadingSectionComponent } from './loading-section/loading-section.component'
import { HistoryListComponent } from './history-list/history-list.component'
import { SelectRentalsTableComponent } from './select-rentals-table/select-rentals-table.component'
import { AvatarComponent } from './avatar/avatar.component'
import { AvatarNameComponent } from './avatar-name/avatar-name.component'
import { CopyIconComponent } from './CopyIcon/CopyIcon.component'
import { CancelFiltersComponent } from './cancel-filters/cancel-filters.component'
import { ShowMoreComponent } from './show-more/show-more.component'
import { RatingComponent } from './rating/rating.component'
import { OpenArticleIdDirective } from './page-help/open-article.directive'
import { AddressFormComponent } from './AddressForm/AddressForm.component'
import { LoadingValueComponent } from './loading-value/loading-value.component'

export * from './help-video-icon/help-video-icon.component'
export * from './page-help/page-help.component'
export * from './page-help/open-article.directive'
export * from './overflow-scroll/overflow-scroll.component'
export * from './circle-progress/circle-progress.component'
export * from './UploadBox/UploadBox.component'
export * from './TinyMceEditor/TinyMceEditor.component'
export * from './TinyMceEditor/options'
export * from './MatPaginator2/MatPaginator2.component'
export * from './select-rentals-table/select-rentals-table.component'
export * from './history-list/history-list.component'
export * from './avatar/avatar.component'
export * from './avatar-name/avatar-name.component'
export * from './cancel-filters/cancel-filters.component'
export * from './show-more/show-more.component'
export * from './time-picker'
export * from './rating/rating.component'
export * from './dropdown'
export * from './AddressForm/AddressForm.component'
export * from './loading-value/loading-value.component'

export const components = [
  //
  HelpVideoIconComponent,
  PageHelpComponent,
  OpenArticleIdDirective,
  OverflowScrollComponent,
  CircleProgressComponent,
  UploadBoxComponent,
  TinyMceEditorComponent,
  MatPaginator2,
  LoadingSectionComponent,
  LoadingValueComponent,
  AvatarComponent,
  AvatarNameComponent,
  HistoryListComponent,
  CopyIconComponent,
  CancelFiltersComponent,
  ShowMoreComponent,
  AddressFormComponent,
  RatingComponent,

  //
  SelectRentalsTableComponent,
]
